import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import { handleMessageChange } from "./handleMessageChange";
import { Button } from "./tailwind/button";
import { Field } from "./tailwind/fieldset";
import { Input } from "./tailwind/input";
import SelectInput from "./tailwind/select-input";
import { Text } from "./tailwind/text";

const DynamicList = ({
  title,
  items,
  setItems,
  stateKey,
  addButtonLabel,
  nodes,
  setNodes,
  keyOptions = [],
  useSelectForKey = false,
}) => {
  const handleAddItem = () => {
    setItems((prevState) => {
      const updatedItems = [...prevState, { key: "", value: "" }];
      handleMessageChange(`${stateKey}`, updatedItems, nodes, setNodes);
      return updatedItems;
    });
  };

  const handleRemoveItem = (index) => {
    setItems((prevState) => {
      if (prevState.length === 1) {
        const updatedState = [...prevState];
        updatedState[0] = { key: "", value: "" };
        handleMessageChange(`${stateKey}`, updatedState, nodes, setNodes);
        return updatedState;
      }
      const filteredState = prevState.filter((_, i) => i !== index);
      handleMessageChange(`${stateKey}`, filteredState, nodes, setNodes);
      return filteredState;
    });
  };

  const handleItemChange = (index, field, value) => {
    setItems((prevState) => {
      const updatedState = [...prevState];
      updatedState[index][field] = value;
      return updatedState;
    });
    handleMessageChange(`${stateKey}`, items, nodes, setNodes);
  };

  return (
    <Field className="mt-2">
      <Text className="mb-1 font-bold">{title}</Text>
      {items.map((item, index) => (
        <div className="flex justify-between h-16 flex-wrap" key={index}>
          <div className="flex flex-col justify-end w-5/12">
            <Text className="text-gray-600 text-sm mb-1 p-0">Key</Text>
            {useSelectForKey ? (
              <>
                <SelectInput
                  placeholder="Select a field"
                  value={item.key}
                  onChange={(value) => handleItemChange(index, "key", value)}
                  options={keyOptions}
                  selected={item.key}
                  key={`config-key-${index}`}
                />
              </>
            ) : (
              <Input
                type="text"
                name={`${stateKey}-key-${index}`}
                value={item.key}
                onChange={(e) => handleItemChange(index, "key", e.target.value)}
                autoComplete="off"
              />
            )}
          </div>
          <div className="flex flex-col justify-end w-5/12">
            <Text className="text-gray-600 text-sm mb-1 p-0">Value</Text>
            <Input
              type="text"
              name={`${stateKey}-value-${index}`}
              value={item.value}
              onChange={(e) => handleItemChange(index, "value", e.target.value)}
              autoComplete="off"
              placeholder={stateKey === "configResponse" ? "data" : ""}
              onFocus={(e) => (window.activeInput = e.target)}
            />
          </div>
          <div className="flex flex-col justify-end h-full">
            <Button
              color="optionButton"
              className="w-9 h-9"
              onClick={() => handleRemoveItem(index)}
            >
              <TrashIcon />
            </Button>
          </div>
        </div>
      ))}
      <Button color="optionButton" className="mt-2" onClick={handleAddItem}>
        <PlusIcon /> {addButtonLabel}
      </Button>
    </Field>
  );
};

export default DynamicList;
